export const careers = [
  {
    id: 1,
    category: "Software Development",
    avalibleJobs: 2,
    positions: [
      {
        id: 301,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 2,
    category: "Design",
    avalibleJobs: 1,
    positions: [
      {
        id: 301,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 3,
    category: "Social Media",
    avalibleJobs: 1,
    positions: [
      {
        id: 301,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 4,
    category: "Content Creation",
    avalibleJobs: 1,
    positions: [
      {
        id: 302,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 5,
    category: "Video Editing ",
    avalibleJobs: 1,
    positions: [
      {
        id: 303,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 6,
    category: "Motion Graphics",
    avalibleJobs: 1,
    positions: [
      {
        id: 304,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 7,
    category: "SEO & SEM",
    avalibleJobs: 1,
    positions: [
      {
        id: 305,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
  {
    id: 8,
    category: "Paid Ads",
    avalibleJobs: 1,
    positions: [
      {
        id: 306,
        title: "Social Media Strategist",
        availableJobs: 1,
        description:
          "Drive the brand’s social media presence by creating impactful strategies, engaging content, and fostering meaningful interactions with the audience.",
        responsibilities: [
          "Develop and execute social media strategies aligned with business goals.",
          "Plan, create, and schedule engaging content across platforms.",
          "Monitor analytics to evaluate performance and optimize campaigns.",
          "Build and nurture online communities while ensuring brand consistency.",
          "Stay updated on social media trends and tools to maintain competitiveness.",
        ],
        requirements: [
          "Proven experience in social media management (2-3 years).",
          "Strong copywriting, content curation, and analytical skills.",
          "Proficiency in social media tools (e.g., Hootsuite) and analytics platforms.",
          "Creative mindset with a focus on brand alignment and audience engagement.",
        ],
        preferredSkills: [
          "Knowledge of SEO and paid advertising strategies.",
          "Experience with influencer collaborations and user-generated content.",
          "Familiarity with design tools (e.g., Canva, Adobe Spark) for visual content.",
        ],
        whyJoinUs: [
          "Collaborate with a dynamic team passionate about digital marketing.",
          "Opportunities to innovate and drive impactful campaigns.",
          "Work in a supportive environment with growth and learning potential.",
        ],
      },
    ],
  },
];
